module.exports = __webpack_public_path__ + "img/user-user.9f54680e.png";